import { CardsFilter } from './cards-filter';

export default CardsFilter;
